import * as React from "react";
import IndexHeader from "app/shared-components/PageHeader";
import { useState } from "react";
import TimeSheetFilter from "./components/TimeSheetFilters";
import TimeSheetTable from "./components/TimeSheetTable";
import { FilterState } from "src/app/@types/interfaces/timesheet.interface";

export default function TimeSheetPage() {
  const [filters, setFilters] = useState<FilterState>({
    week: null,
    worksite: null,
    status: null,
    program: null,
    name: null,
    id: null,
  });

  const handleFilterChange = (newFilters: FilterState) => {
    setFilters(newFilters);
  };

  return (
    <>
      <IndexHeader
        name={"Timesheet"}
        update={false}
        add={false}
        redirectingPath={""}
        noButtons={true}
      />
      <TimeSheetFilter onFilterChange={handleFilterChange} />
      <TimeSheetTable filters={filters} />
    </>
  );
}
